<template>
  <div>
    <SimpleDataTable
        :title="title"
        :description="''"
        :dataList="bestStockList"
        :dataHeaders="bestStockListHeaders"
        :loading="bestStockListLoading"
        :pagination-status="true"
        :pagination-length="maxPage"
        @page-change="handlePageChange"
        :error-message="errorMessage"
    >
      <template v-slot:filterAndAction>
        <v-text-field
            style="margin-right: 5px"
            v-model="searchTextFilter"
            filled
            solo
            dense
            append-icon="mdi-magnify"
            @click:append="_fetchBestStockList"
            @keydown.enter="_fetchBestStockList"
            hide-details
            placeholder="Kelime girin..."
        >

        </v-text-field>
        <v-select
            style="margin-right: 5px; max-width: 300px"
            v-model="sortFilter"
            filled
            solo
            dense
            :items="erpSettings.netsisCurrencySale ? [
            { value:1,text:'Miktar => Büyükten Küçüğe' },
            { value:2,text:'Tl Fiyat => Büyükten Küçüğe' },
            { value:3,text:'Dövizli Fiyat => Büyükten Küçüğe' },
          ]: [
            { value:1,text:'Miktar => Büyükten Küçüğe' },
            { value:2,text:'Tl Fiyat => Büyükten Küçüğe' },
          ]"
            item-value="value"
            item-text="text"
            hide-details
            @change="_fetchBestStockList"
            @keydown.enter="_fetchBestStockList"
            placeholder="Kelime girin..."
        >

        </v-select>
        <v-select
            v-model="timePeriodFilterValue"
            :items="[
                      {value: 5, text: 'Tarih Aralığı'},
                      {value: 4, text: 'Yıllık'},
                      {value: 3, text: 'Aylık'},
                      {value: 2, text: 'Haftalık'},
                      {value: 1, text: 'Günlük'}
                  ]"
            style="max-width: 100px"
            label=""
            item-text="text"
            item-value="value"
            filled
            solo
            hide-details
            dense
            @change="timePeriodFilterValue !== 5  ? _fetchBestStockList : null"
            @keydown.enter="timePeriodFilterValue !== 5  ? _fetchBestStockList : null"
        >

        </v-select>
        <div v-if="timePeriodFilterValue === 5">
          <v-menu
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  :value="formattedDate(dateRangeStartFilterValue)"
                  placeholder="Filtre Başlangıç Tarihi"
                  class="m-1"
                  readonly
                  filled
                  solo
                  dense
                  clearable
                  @click:clear="dateRangeStartFilterValue = null"
                  hide-details
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="dateRangeStartFilterValue"
                locale="tr"
                :max="dateRangeEndFilterValue ? dateRangeEndFilterValue : 'NaN-Nan-Nan'"
            ></v-date-picker>
          </v-menu>
          <v-menu
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  :value="formattedDate(dateRangeEndFilterValue)"
                  placeholder="Filtre Bitiş Tarihi"
                  readonly
                  solo
                  filled
                  class="m-1"
                  dense
                  clearable
                  @click:clear="dateRangeEndFilterValue = null"
                  hide-details
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="dateRangeEndFilterValue"
                locale="tr"
                :min="dateRangeStartFilterValue"
            ></v-date-picker>
          </v-menu>
          <div class="w-100 text-center">
            <v-btn
                x-small
                class="mx-auto"
                color="primary darken-2"
                @click="_fetchBestStockList"
            >
              FİLTRELE
            </v-btn>
          </div>

        </div>
      </template>
    </SimpleDataTable>
  </div>

</template>

<script>

import SimpleDataTable from "@/components/dashboard/SimpleDataTable";
import {mapActions, mapState} from "vuex";
import {numberConverter} from "../../../../helpers";
import {formattedDate} from "@/momentHelper";

export default {
  name: "EnIyiSatilanUrunler",
  components: {
    SimpleDataTable,
  },
  props: {
    title: {
      type: String,
      default: null
    },
    dashboardFilterCurrentCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterSalesPersonCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterReportDbNameProp: {
      type: String,
      default: null
    },
    pageSizeProp: {
      type: Number,
      default: null
    },
  },
  computed: {
    ...mapState("settings", ["erpSettings"]),
    ...mapState("auth", ["user"])
  },
  mounted() {
    this._fetchBestStockList()
  },
  data() {
    return {
      maxPage: null,
      currentPage: 1,
      bestStockList: [],
      bestStockListHeaders: [],
      bestStockListLoading: false,
      searchTextFilter: null,
      sortFilter: 1,
      timePeriodFilterValue: 4,
      dateRangeStartFilterValue: null,
      dateRangeEndFilterValue: null,
      bestSellStocksDataLoading: true,
      errorMessage: "",
    }
  },
  methods: {
    ...mapActions("dashboard", ["fetchBestStockList"]),
    numberConverter,
    formattedDate,
    async handlePageChange(newPage) {
      this.currentPage = newPage;
      await this._fetchBestStockList();
    },
    _fetchBestStockList() {
      this.bestStockListLoading = true;

      const requestData = {
        params: {
          userId: this.user.UserId,
          pageNumber: this.currentPage,
          ...(!(this.pageSizeProp === "" || this.pageSizeProp == null)) && {pageSize: this.pageSizeProp}
        },
        body: {
          CodeType: null,
          DateType: this.timePeriodFilterValue,
          Code: null,
          OrderBy: this.sortFilter,
          SearchText: this.searchTextFilter,
          ...(!(this.dashboardFilterCurrentCodeProp === "" || this.dashboardFilterCurrentCodeProp == null)) && {currentCode: this.dashboardFilterCurrentCodeProp},
          ...(!(this.dashboardFilterSalesPersonCodeProp === "" || this.dashboardFilterSalesPersonCodeProp == null)) && {salesPersonCode: this.dashboardFilterSalesPersonCodeProp},
          ...(!(this.dashboardFilterReportDbNameProp === "" || this.dashboardFilterReportDbNameProp == null)) && {reportDbName: this.dashboardFilterReportDbNameProp},
          ...(!(this.timePeriodFilterValue === "" || this.timePeriodFilterValue == null)) && {
            DateType: this.timePeriodFilterValue,
          },
        }
      }

      if (this.timePeriodFilterValue === 5) {
        requestData.body.startDate = this.dateRangeStartFilterValue;
        requestData.body.endDate = this.dateRangeEndFilterValue;
      }

      this.fetchBestStockList(requestData).then(result => {
        this.bestStockList = [];
        this.bestStockListLoading = false;
        this.bestSellStocksDataLoading = false;
        if (result && result.data.success) {
          this.bestStockListHeaders = this.erpSettings.netsisCurrencySale ? [
            {
              key: 'stockCode',
              label: 'Stok Kodu',
              sortable: false,
            },
            {
              key: 'stockName',
              label: 'Stok Adı',
              sortable: false,
            },
            {
              class: 'text-right',
              key: 'quantity',
              label: 'Miktar',
              sortable: false,
            },
            {
              class: 'text-right',
              key: 'vatExcludedPrice',
              label: 'Satış Tutarı (TL)',
              sortable: false,
            },
            {
              class: 'text-right',
              key: 'vatExcludedCurrencyPrice',
              label: 'Dövizli Satış Tutarı',
              sortable: false,
            },
            {
              class: 'text-right',
              key: 'vatExcludedPrice',
              label: 'KDV Dahil Fiyat',
              sortable: false,
            },
          ] : [
            {
              key: 'stockCode',
              label: 'Stok Kodu',
              sortable: false,
            },
            {
              key: 'stockName',
              label: 'Stok Adı',
              sortable: false,
            },
            {
              class: 'text-right',
              key: 'quantity',
              label: 'Miktar',
              sortable: false,
            },
            {
              class: 'text-right',
              key: 'vatExcludedPrice',
              label: 'Satış Tutarı (TL)',
              sortable: false,
            },
            {
              class: 'text-right',
              key: 'vatExcludedPrice',
              label: 'KDV Dahil Fiyat',
              sortable: false,
            },
          ];
          this.bestStockList = result.data.data;
          //number
          this.maxPage = result.data.totalPages;
          this.bestStockList.forEach((elem) => {
            elem.quantity = this.numberConverter(elem.quantity);
            elem.vatExcludedCurrencyPrice = this.numberConverter(elem.vatExcludedCurrencyPrice);
            elem.vatExcludedPrice = this.numberConverter(elem.vatExcludedPrice);
            elem.vatIncludedCurrencyPrice = this.numberConverter(elem.vatIncludedCurrencyPrice);
          });
        } else  {
          this.bestStockList = [];
          this.errorMessage = result.data.message;
        }
      })
    }
  },
  watch: {
    dashboardFilterCurrentCodeProp(newVal) {
      newVal;
      this._fetchBestStockList()
    },
    dashboardFilterSalesPersonCodeProp(newVal) {
      newVal;
      this._fetchBestStockList()
    },
    dashboardFilterReportDbNameProp(newVal) {
      newVal;
      this._fetchBestStockList()
    },
    timePeriodFilterValue(newVal) {
      newVal;
      if (newVal === 5) return;
      this._fetchBestStockList()
    },
  }
}
</script>

<style scoped>

</style>